import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const TemplateCard = ({ title, description, type }) => {
  const handleDownload = (format) => {
    window.location.assign(`${process.env.REACT_APP_BACKEND_URL}/api/templates/${type}?format=${format}`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <p className="text-sm text-muted-foreground">{description}</p>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" onClick={() => handleDownload('csv')}>
            Descargar CSV
          </Button>
          <Button variant="outline" onClick={() => handleDownload('xlsx')}>
            Descargar XLSX
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

const Templates = () => (
  <div className="max-w-5xl mx-auto space-y-6" data-testid="client-templates-page">
    <div>
      <h1 className="text-4xl font-heading font-bold">Plantillas</h1>
      <p className="text-muted-foreground">Descarga las plantillas oficiales para completar y subir.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <TemplateCard
        title="Contactos"
        description="Clientes y proveedores. Incluye campos obligatorios y ejemplo."
        type="contacts"
      />
      <TemplateCard
        title="Cuentas bancarias"
        description="Cuentas para conciliacion y pagos."
        type="bank_accounts"
      />
      <TemplateCard
        title="Facturas mensuales"
        description="Archivo mensual con cabecera + lineas."
        type="invoices"
      />
      <TemplateCard
        title="Gastos mensuales"
        description="Archivo mensual con cabecera + lineas."
        type="expenses"
      />
    </div>
  </div>
);

export default Templates;
